const parseResponse = (response: any) => {
  const errors = response._data?.errors || []
  let message = 'Ocorreu um erro inesperado, tente novamente'

  if (response._data?.preFormatted) {
    message = response._data?.message
  }

  if (errors.length > 0) {
    if (errors.length > 1) {
      message = `<ul style="text-align: left;">
          ${errors.map((m: any) => `<li>${m}</li>`).join('')}
        </ul>`
    } else {
      message = errors.shift()
    }
  }
  return {message, status: response.status || 500}
}

export const useAjax = () => {
  const cfx = {path: '/', watch: true};
  const userAdmId = useCookie('user-session-team-adm-id', cfx)
  const {signOut, token} = useAuth()

  const config = useRuntimeConfig()
  const requestHeaders = useRequestHeaders(['cookie'])

  const apiClient = $fetch.create({
    baseURL: import.meta.server ? config.apiUrl : config.public.apiUrl,
    credentials: 'include',

    onRequest({request, options}) {
      options.headers = {
        ...requestHeaders,
        ...options.headers,
        //@ts-ignore
        'Authorization': token.value ? `Bearer ${token.value}` : null,
        'user-session-team-adm-id': userAdmId.value || null
      }

      Object.keys(options.headers).forEach(key => {
        //@ts-ignore
        if (options.headers[key] === null || options.headers[key] === undefined) {
          //@ts-ignore
          delete options.headers[key]
        }
      })
    },

    onResponseError({request, response, options}) {
      const url = typeof request === 'string' ? request : request.url

      if (response.status === 401 && !url.includes('/auth')) {
        signOut()
      }

      if (response.status === 403) {
        navigateTo('/403')
      }

      console.error(`[API Error] ${response.status}: ${url}`, response._data)
    }
  })

  const fetch = async <T = any>(url: string, options: any = {}): Promise<T> => {
    try {
      return await apiClient<T>(url, options)
    } catch (e: any) {
      const error = parseResponse(e.response)
      throw createError(error)
    }
  }

  return {fetch}
}
